// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"0ec74aa2","453":"7db0242e"}[chunkId] + ".chunk.js";
};